import KnowledgeBaseManagement from '@/pages/Admin/KnowledgeBase/KnowledgeBaseManagement';
export default KnowledgeBaseManagement;
